import React, { useState } from "react";
import { Container, Col, Row, Button, Form, Card } from "react-bootstrap";
import AllHeader from "../../components/AllHeader";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LoaderBtn from "../../components/LoaderBtn";
import { toast } from "react-toastify";
import axiosInstance from "../../api/axiosInstance";

function SabtDarkhast() {
  const [load, setLoad] = useState(false);
  const [description, setDescription] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const { RecordType, RecordStatus } = location.state || {};
  const navigate = useNavigate();


  const handleSubmit = (e) => {
    e.preventDefault();
    if (isChecked === false && description === "") {
      toast.error("لطفا اطلاعات را تکمیل نمایید", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    } else {
      setLoad(true);
      axiosInstance
        .post("ChangeStateMade100", {
          Text: isChecked === true ? ""  : description,
          RecordId: id,
          Status: RecordType === 1 ? 3 : 4
        })
        .then((res) => {
          if (res.data.result === "true") {
            toast.success(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
            navigate("/eblaghelectronici");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        })
        .finally(() => {
          setLoad(false);
          setDescription("");
        });
    }
  };

  const handleCheckboxChange = (e) => {
    const check = e.target.checked;
    setIsChecked(check);
    if (check === true) {
      setDescription("");
    }
  };

  return (
    <div className="rgc-pages">
      <AllHeader>
        <span>ابلاغیه الکترونیکی</span>
      </AllHeader>
      <Container>
        <Card className="rgc-card-form p-2 p-md-5">
          <Row className="justify-content-center justify-content-md-end gy-4">
            <Col md="12">
              <Form>
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlTextarea1"
                >
                  <Form.Label>شرح:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={5}
                    className="rgc-font-number"
                    placeholder=""
                    type="text"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    disabled={isChecked}
                  />
                </Form.Group>

                <Form.Group
                  className="rgc-form-check mb-3"
                  controlId="formBasicCheckbox"
                >
                  <Form.Check
                    type="checkbox"
                    onChange={handleCheckboxChange}
                    label={
                      RecordType === 1
                        ? "دفاعیاتی ندارم و تقاضا دارم بدون در نظر گرفتن فرصت دفاعیات،  در اولین کمیسیون ماده صد پرونده اینجانب مطرح گردد"
                        : "اعتراض به رای صادره بدوی نداشته و تقاضای ارجاع پرونده به شهرداری منطقه مربوطه جهت ادامه روند اداری را دارم"
                    }
                  />
                </Form.Group>  
                <div className="d-flex justify-content-center">      
                    <Button
                      variant="primary"
                      type="submit"
                      onClick={handleSubmit}
                      className="btn-height d-flex justify-content-center align-items-center"
                    >
                      {load === true ? (
                        <LoaderBtn loads={load} />
                      ) : (
                        <span>ثبت</span>
                      )}
                    </Button>
                    </div>  
              </Form>
            </Col>
          </Row>
        </Card>
      </Container>
    </div>
  );
}

export default SabtDarkhast;
